import React from 'react';
import { Route, Routes, BrowserRouter, } from 'react-router-dom';
import Destination from './pages/ITP/Destination';
import TravelDates from './pages/ITP/TravelDates';
import DevicesAndPlans from './pages/ITP/DevicesAndPlans';
import PlanSelection from './pages/ITP/PlanSelection';
import CruisePlanSelection from './pages/ITP/CruisePlanSelection';
import SkipNewPlan from './pages/ITP/SkipNewPlan';
import { intlBaseUrl } from './shared/utils/globalConfig';
import Confirmation from './pages/ITP/Confirmation';
import EffectiveDate from './pages/ITP/EffectiveDate'
import DevicesUnauth from './pages/ITP/DevicesUnauth';

const Router = () => (

  <BrowserRouter basename={intlBaseUrl}>
    <Routes>
      <Route path="/itpdestination" element={<Destination />} />
      <Route path="/itptraveldates" element={<TravelDates />} exact />
      <Route path="/itpdevicesandplans" element={<DevicesAndPlans />} exact />
      <Route path="/itpplanselection" element={<PlanSelection />} exact />
      <Route path="/itpcruiseplanselection" element={<CruisePlanSelection />} exact />
      <Route path="/" element={<Destination />} />
      <Route path="/itpconfirmation" element={<Confirmation/>} exact />
      <Route path="/itpeffectivedate" element={<EffectiveDate/>} exact />
      <Route path="/itpskipplan" element={<SkipNewPlan />} exact />

      <Route path="/uaitpdestination" element={<Destination />} exact/>
      <Route path="/uaitptraveldates" element={<TravelDates />} exact />
      <Route path="/uaitpdevicesandplans" element={<DevicesUnauth />} exact />
      <Route path="/uaitpplan" element={<PlanSelection />} exact />
      <Route path="/uaitpcruiseplan" element={<CruisePlanSelection />} exact />
      <Route path="/uaitpskipplan" element={<SkipNewPlan />} exact />
      <Route path="/uasummary" element={<Confirmation />} exact />
      
    </Routes>
  </BrowserRouter>
);

export default Router;
